export const en = {
  // Header
  title: "Employee Management System",
  subtitle: "Comprehensive management of employee data and status tracking",

  // Buttons
  addEmployee: "Add New Employee",
  add: "Add",
  export: "Export",
  share: "Share",
  archive: "View Archive",
  cancel: "Cancel",
  update: "Update Employee",
  save: "Save",
  delete: "Delete",
  restore: "Restore",
  restoreAll: "Restore All",
  deleteAll: "Delete All",
  updating: "Updating...",
  adding: "Adding...",

  // Table Headers
  employee: "Employee",
  department: "Department",
  joinDate: "Join Date",
  status: "Status",
  actions: "Actions",
  archivedDate: "Archived Date",
  company: "Company",

  // Departments
  infotech: "Information Technology",
  humanResources: "Human Resources",
  finance: "Finance",
  marketing: "Marketing",
  operations: "Operations",
  sales: "Sales",
  customerService: "Customer Service",

  // Filters
  filtersActions: "Filters & Actions",
  showing: "Showing",
  of: "of",
  records: "records",
  searchEmployee: "Search Employee",
  searchBy: "Search by",
  searchClientCode: "Search client code...",
  searchNationalId: "Search national ID...",
  allDepartments: "All Departments",
  allStatuses: "All Statuses",
  allCompanies: "All Companies",
  searchDepartment: "Search Department",
  selectStatus: "Select Status",

  // Stats
  totalEmployees: "Total Employees",
  activeEmployees: "Active Employees",
  onLeave: "On Leave",
  archived: "Archived",
  you: "you",
  notInCount: "Other employees + you",
  newEmployees: "New Employees",
  total: "Total",
  active: "Active",
  currentlyWorking: "Currently working",
  currentlyOnLeave: "Currently on leave",
  archivedEmployees: "Archived Employees",
  joinedRecently: "Joined Recently",
  allRegisteredEmployees: "All registered employees",
  allEmployees: "All employees",

  // Status
  statusActive: "Active",
  statusOnLeave: "On Leave",
  statusInactive: "Inactive",
  statusArchived: "Archived",
  statusUnknown: "Unknown",

  // Messages
  loading: "Loading...",
  loadingEmployees: "Loading employees...",
  showMore: "Show more",
  noEmployees: "No employees found",
  noArchivedEmployees: "No archived employees found",
  employeesArchivedMessage: "Employees that are archived will appear here",
  showAll: "Show All",
  showLess: "Show Less",
  more: "more",

  // Modals
  employeeDetails: "Employee Details",
  editEmployee: "Edit Employee",
  addNewEmployee: "Add New Employee",
  viewArchive: "Archived",
  archivedDescription:
    "Archived employees are safely stored here. You can restore them to active status or permanently delete them.",

  // Form Labels
  fullName: "Full Name",
  emailAddress: "Email Address",
  phoneNumber: "Phone Number",
  nationalId: "National ID",
  position: "Position",
  laborMode: "Labor Mode",
  lastContractTerm: "Last Contract Term",
  companyName: "Company",
  clientCode: "Client Code",
  statusLabel: "Status",
  salaryLabel: "Salary",
  dateOfBirth: "Date of Birth",
  gender: "Gender",
  maritalStatus: "Marital Status",
  nationality: "Nationality",
  city: "City",
  country: "Country",
  address: "Address",
  emergencyPhone: "Emergency Phone",

  // Form Placeholders
  enterFullName: "Enter full name",
  enterEmail: "Enter email address",
  enterPhone: "Enter phone number",
  enterNationalId: "Enter national ID",
  enterPosition: "Enter position",
  enterCompany: "Enter company name",
  enterClientCode: "Enter client code",
  enterSalary: "Enter salary amount",
  selectGender: "Select Gender",
  selectMaritalStatus: "Select Status",
  enterNationality: "Enter nationality",
  enterCity: "Enter city",
  enterCountry: "Enter country",
  enterAddress: "Enter full address",
  searchNameIdEmail: "Name, insurance no., email, phone...",
  searchNameId: "Name, ID...",

  // Form Sections
  basicInformation: "Basic Information",
  workInformation: "Work Information",
  personalInformation: "Personal Information",
  contactInformation: "Contact Information",
  educationInformation: "Education Information",
  insuranceInformation: "Insurance Information",
  systemInformation: "System Information",

  // Gender Options
  male: "Male",
  female: "Female",

  // Marital Status Options
  single: "Single",
  married: "Married",
  divorced: "Divorced",
  widowed: "Widowed",

  // Labor Mode Options (insource vs outsource)
  insource: "Insource",
  outsource: "Outsource",
  selectLaborMode: "Select Labor Mode",

  // Last Contract Term Options
  fullTime: "Full-time",
  partTime: "Part-time",
  contract: "Contract",
  temporary: "Temporary",
  freelance: "Freelance",
  selectLastContractTerm: "Select Last Contract Term",

  // Info Labels
  email: "Email",
  phone: "Phone",
  employeeId: "Employee ID",
  hiringDate: "Hiring Date",
  workingExperience: "Working Experience",
  contractDate: "Contract Date",
  contractExpiration: "Contract Expiration",
  termOfContract: "Term of Contract",
  insuranceStatus: "Insurance Status",
  insuranceNumber: "Insurance Number",
  insuranceSalary: "Insurance Salary",
  insuranceStartDate: "Insurance Start Date",
  monthsForInsurance: "Months for Insurance",
  graduateInstitution: "Graduate Institution",
  major: "Major",
  graduationYear: "Graduation Year",
  createdAt: "Created At",
  lastUpdated: "Last Updated",
  years: "years",
  months: "months",

  // Action Buttons
  viewDetails: "View Details",
  deleteEmployee: "Delete Employee",
  archiveEmployee: "Archive Employee",
  restoreEmployee: "Restore Employee",
  permanentlyDelete: "Permanently Delete",

  // Confirmation Messages
  confirmDelete: "Are you sure you want to delete this employee?",
  confirmArchive: "Are you sure you want to archive this employee?",
  confirmRestore: "Are you sure you want to restore this employee?",
  confirmPermanentDelete:
    "Are you sure you want to permanently delete this employee? This action cannot be undone.",
  confirmRestoreAll: "Are you sure you want to restore all",
  archivedEmployeesQuestion: "archived employees?",
  confirmDeleteAll: "Are you sure you want to permanently delete all",
  cannotBeUndone: "This action cannot be undone.",

  // Success Messages
  employeeUpdated: "Employee updated successfully!",
  employeeAdded: "Employee added successfully!",
  employeeDeleted: "Employee deleted successfully!",
  employeeArchived: "Employee archived successfully!",
  employeeRestored: "Employee restored successfully!",
  allEmployeesDeleted: "All archived employees permanently deleted!",
  exportSuccess: "Exported",
  filteredEmployees: "filtered employees successfully!",
  exportSuccessCSV: "filtered employees as CSV!",

  // Error Messages
  nameRequired: "Name is required",
  emailRequired: "Email is required",
  emailInvalid: "Email is invalid",
  departmentRequired: "Department is required",
  positionRequired: "Position is required",
  clientCodeRequired: "Client Code is required",
  failedToFetch: "Failed to fetch employee",
  failedToUpdate: "Failed to update employee",
  failedToAdd: "Failed to add employee",
  failedToDelete: "Failed to delete employee",
  failedToArchive: "Failed to archive employee",
  failedToRestore: "Failed to restore employee",
  failedToExport: "Failed to export employees data",
  serverError: "Server error during import",
  importFailed: "Import failed:",
  Status: "Status",

  // Archive Stats
  totalArchived: "Total Archived",
  archivedThisMonth: "Archived This Month",
  archivedEmployee: "archived employee",

  // Import Messages
  imported: "Imported",
  employeesSuccessfully: "employees successfully.",
  failedRows: "Failed rows:",
  row: "Row",

  // List Labels
  employeeList: "Employee List",
  employeesCount: "employees",
  employees: "Employees",

  viewDocuments: "View Documents",
  documents: "Documents",
  noDocuments: "No documents found",
  download: "Download",
  documentChecklist: "Document Checklist",
  photos: "Photos",
  birthForm: "Birth Certificate",
  graduation: "Graduation Certificate",
  idCopy: "ID Copy",
  criminalRecord: "Criminal Record",
  workCertificate: "Work Certificate",
  form111: "Form 111",
  updatingDocuments: "Updating documents...",
  documentsUpdated: "Documents updated successfully!",
  failedToUpdateDocuments: "Failed to update documents",

  // Not Available
  na: "N/A",
};

export default en;
